"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FooterContent = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _api = require("../../api");
var _components = require("../../components");
var _contexts = require("../../contexts");
var _useReopenCookiePreferences = require("../../hooks/useReopenCookiePreferences");
var _FooterAppSkeleton = require("../FooterAppSkeleton");
var _constants = require("./constants");
var _hooks = require("./hooks");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const FooterContent = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobileOffice = (0, _hooks.useIsMobileOffice)();
  (0, _useReopenCookiePreferences.useReopenCookiePreferences)();
  const {
    data: footerContent
  } = (0, _api.useGetFooterContent)();
  const footerProviderValue = (0, _react.useMemo)(() => {
    if (!footerContent) {
      return {
        ..._contexts.defaultFooterContext,
        isMobileOffice
      };
    }
    return {
      isMobileOffice,
      ...footerContent
    };
  }, [footerContent, isMobileOffice]);
  if (!footerContent) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FooterAppSkeleton.FooterAppSkeleton, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_contexts.FooterProvider, {
    value: footerProviderValue,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
      "data-testid": getTestId(_constants.FOOTER_CONTENT),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Subscribe, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Highlight, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.HighlightGrid, {
          isMobileOffice: isMobileOffice,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.SiteLinks, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.FourthColumn, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MobileApps, {})
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.BottomContent, {
        isMobileOffice: isMobileOffice,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FollowUs, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MobileApps, {
          hideOnDesktop: true
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ContentFrontPage, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ContentAllPages, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.MarketExceptions, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.CopyrightWithLinks, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.LanguageSelector, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PaymentMethods, {})]
      })]
    })
  });
};
exports.FooterContent = FooterContent;